// ========= START: src/utils/tts.js (Complete File) =========

// This is a browser-based audio context that allows us to play raw audio data.
// It is defined once here, outside the function, for efficiency.
const audioContext = new (window.AudioContext || window.webkitAudioContext)();

/**
 * Sends text and a voice preference to our backend server.
 * The server uses Google WaveNet to generate speech, and the resulting
 * audio is then played in the browser.
 * @param {string} text - The text to be spoken.
 * @param {string} voice - The voice to use (e.g., 'FEMALE_SARAH', 'MALE_DAVID').
 * @param {Function} onEndCallback - A function to call when the speech is finished.
 */
export const speak = async (text, voice, onEndCallback) => {
  try {
    console.log(`[Frontend] Sending text to backend with voice: ${voice}`);

    // ========== MODIFICATION START ==========
    // The URL is now a relative path.
    // On the live site, this will correctly call `https://bplabo.jp/api/tts`.
    // On your local PC, the proxy will forward this to `http://localhost:3001/api/tts`.
    const response = await fetch('/api/tts', {
    // ========== MODIFICATION END ==========
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ text, voice }),
    });

    if (!response.ok) {
      throw new Error(`Server error: ${response.statusText}`);
    }

    const audioData = await response.arrayBuffer();
    const audioBuffer = await audioContext.decodeAudioData(audioData);
    const source = audioContext.createBufferSource();
    source.buffer = audioBuffer;
    source.connect(audioContext.destination);
    
    if (onEndCallback) {
        source.onended = onEndCallback;
    }

    source.start(0);

  } catch (error) {
    console.error('Error fetching or playing TTS audio:', error);
    if (onEndCallback) {
      onEndCallback();
    }
  }
};

// ========= END: src/utils/tts.js (Complete File) =========